import AlertsviewTable from '@containers/main/alerts/alertsview-table'
import {Collapse} from 'antd'
import {useState} from 'react'
import {useDomain} from 'contexts/DomainContext'

const {Panel} = Collapse

const GatewayAlerts = ({gatewaysview}) => {
  const [activeKey, setActiveKey] = useState(null) // Controls which panel is open
  const {terms} = useDomain()

  const handleChange = key => {
    // Toggle the panel: if the same key is clicked again, close it
    setActiveKey(activeKey === key ? null : key)
  }

  return (
    <Collapse activeKey={activeKey} onChange={handleChange}>
      <Panel header={terms.alerts || 'Alerts'} key="1" className="custom-panel">
        <AlertsviewTable
          query={{g_id: gatewaysview.g_id}}
          excludeItemInfo={false}
          showFilter={false}
          showLimit={false}
        />
      </Panel>
    </Collapse>
  )
}

export default GatewayAlerts
